import Translation from './translation'


export default class About extends Translation
{
    set Image(value){
        if(value != null){
            this.image = value
            this.picture = URL.createObjectURL(value)
        }else{
            this.image = null
            this.picture = this.image_url
        }
    }
        
    get ImageName(){
        var path = require('path');
        return this.image != null
            ? path.basename(this.image.value)
            : path.basename(this.image_url);
    }

    get ImageType(){
        return this.image != null
            ? this.image.type
            : this.ImageName.split('.').pop()
    }

    constructor(about){
        super()
        this.id             = 0
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.content_ar     = ''
        this.content_en     = ''
        this.content_fa     = ''

        this.thumbnails     = {}
        this.image          = null
        this.get_image_url  = null
        this.image_url      = null
        this.picture        = null
        this.tags           = []

        this.editor_images  = []
        this.map(about)
        this.init()
    }

    map(about){
        if(about == undefined) return
        this.id             = about.id
        this.get_image_url  = about.get_image_url
        this.image_url      = about.image_url
        this.picture        = ''
        this.thumbnails     = about.thumbnails
        
        this.tags           = about.tags??[]
        this.created_at     = about.created_at  
        this.updated_at     = about.updated_at  

        for (let locale of this.appLocales) {

            this['title_' + locale.code] = about.translations[locale.code].title
            this['content_' + locale.code] = about.translations[locale.code].content
        }
        this.setLocale(this.appLocales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.appLocales){

            fData.append('translation['+ locale.code +'][title]', this['title_'+ locale.code]);
            fData.append('translation['+ locale.code +'][content]', this['content_'+ locale.code]);
        }
        
        if(this.image != null){
            fData.append('image', this.image);
        }

        this.tags.forEach(tag=>fData.append('tags[]', tag))

        this.editor_images.forEach(img=>fData.append('editor_images[]', img.id))
        alert(this.editor_images)
        return fData
    }
}

